// extracted by mini-css-extract-plugin
module.exports = {"root":"ChevronBackCircleOutline_root__rAsdz"};